import { SetStateAction } from 'react';
import { FormatUtils } from '@shared/utils';
import { GetAllCardsResponse } from '@shared/api';
import { Button } from '@shared/widgets';

interface SuccessType {
  amount: string;
  currency: string;
  fee: number | null;
  finalFee: string;
  finalAmount: string;
  onClose: (value: SetStateAction<GetAllCardsResponse | null>) => void;
}

export const Success = (props: SuccessType) => {
  return (
    <div className='flex flex-col items-center gap-[56px] opacity-100 transition-opacity duration-300'>
      <section className='h-[444px] w-[498px]'>
        <h2 className='m-0 mb-9 p-0 text-center text-5xl leading-[48px] font-semibold text-[#000]'>Payment was successful</h2>
        <div className='mx-auto w-[343px] bg-[#f4f4f4] p-5 font-light'>
          <div className='flex w-full justify-between'>
            <span className='text-[#3c3c43] opacity-60'>Amount</span>
            <span className='text-[#808084]'>
              {props.currency}
              {FormatUtils.formatMoney(+props.amount)}
            </span>
          </div>
          <div className='flex w-full justify-between'>
            <span className='text-[#3c3c43] opacity-60'>{props.fee}% fee</span>
            <span className='text-[#808084]'>
              {props.currency}
              {FormatUtils.formatMoney(+props.finalFee)}
            </span>
          </div>
          <hr />
          <div className='flex w-full justify-between text-xl font-semibold text-[#272727]'>
            <span>Total</span>
            <span>
              {props.currency}
              {FormatUtils.formatMoney(+props.finalAmount)}
            </span>
          </div>
        </div>
      </section>
      <div className='flex w-full items-stretch justify-center'>
        <Button className='!h-auto w-[75%] !p-6' onClick={() => props.onClose(null)}>
          OK
        </Button>
      </div>
    </div>
  );
};
